<div class="modal-content">
  <person-form
    [isEditMode]="isEditMode"
    [data]="item"
    (processCompleted)="onProcessCompleted($event)"></person-form>
</div>
